import { downloadBlobFromResponse, getCsrfValue } from "../../api/ApiHelper";
import { resolveApiUrl } from "../../utils/url/urlResolver";
import { type QueryType } from "../components/ABMonitorSearchBox/components/SearchByInput/SearchByInput";

export enum ReportType {
  CSV = "1",
  XLSX = "0",
}

export interface ABmonitorForm {
  filterByOption: QueryType;
  filterByValue: string;
  startDate?: Date;
  endDate?: Date;
  lineStatus?: string;
  deliveryDate?: string;
}

export const downloadABMonitorReport = (data: ABmonitorForm, type: ReportType): Promise<any> => {
  const url = resolveApiUrl(`/abmonitor/report/${type}`);

  return fetch(url, {
    body: JSON.stringify(data),
    credentials: "same-origin", // include, omit
    mode: "cors", // no-cors, same-origin
    referrer: "no-referrer", // client
    method: "POST",
    headers: {
      "content-type": "application/json",
      CSRFToken: getCsrfValue(),
    },
  })
    .then(downloadBlobFromResponse)
    .catch((error) => {
      console.warn(error);
    });
};
